import { memo } from 'react'

import { FormattedMessage } from 'react-intl'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import { useImportCSVData } from 'app/store/importCSV'
import { STEP_PROGRESS_THREE } from 'app/constants/subscriberCRM'

import { IMPORT_PROCESS_TYPE } from '../constansts'
import StepIcon from './StepIcon'
import useStyles, { Connector } from './styles'

const StepProgressBar = () => {
  const classes = useStyles()
  const steps = [
    'subscribers.import.steps.step1.label',
    'subscribers.import.steps.step2.label',
    'subscribers.import.steps.step3.label',
  ]
  const {
    activeStep,
    data: { rows, validationInfo },
  } = useImportCSVData()

  const { type, chunkCount, validatedChunkCount } = validationInfo

  const getactiveStep = (activeStep) => {
    if (
      activeStep === STEP_PROGRESS_THREE &&
      !rows.length &&
      type === IMPORT_PROCESS_TYPE &&
      chunkCount === validatedChunkCount
    ) {
      return activeStep
    }
    return activeStep - 1
  }

  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel
        activeStep={getactiveStep(activeStep)}
        connector={<Connector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={StepIcon}
              className={classes.stepLabel}
            >
              <FormattedMessage id={label} />
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  )
}

export default memo(StepProgressBar)
